import { createEntityAdapter } from '@reduxjs/toolkit';

import { createAppSlice } from 'creators';

import { get, post } from 'api/requests';

import { IParamsReq } from 'types';
import {
  DeliveryScheduleDetailData,
  DeliveryScheduleDetailStore,
} from 'pages/DeliveryScheduleDetail/types';
import { IUpdateForecastDatesParams } from 'features/DeliveryScheduleDetail/TableDeliveryScheduleDetail/types';

const initialState: DeliveryScheduleDetailStore = createEntityAdapter().getInitialState({
  detailsData: {} as DeliveryScheduleDetailData,
  loadingData: false,
  requestId: undefined,
  updateDateLoading: false,
});

export const deliveryScheduleDetailSlice = createAppSlice({
  name: 'scheduleTransferDetails',
  initialState,
  reducers: create => ({
    reset: create.reducer(() => initialState),
    fetchDetailsData: create.asyncThunk(
      async (params: IParamsReq, thinkApi) => {
        try {
          const response = await get<DeliveryScheduleDetailData>(
            '/api/v2/settlement/plan-gp/',
            params,
          );
          return response.data;
        } catch (error) {
          return thinkApi.rejectWithValue(error);
        }
      },
      {
        pending: (state, { meta }) => {
          return { ...state, requestId: meta.requestId, loadingData: true };
        },
        rejected: (state, { meta }) => {
          if (state.requestId === meta.requestId) {
            state.loadingData = false;
          }
        },
        fulfilled: (state, { payload }) => {
          state.loadingData = false;

          if (payload) {
            state.detailsData = payload;
            state.requestId = undefined;
          }
        },
      },
    ),
    updateForecastDates: create.asyncThunk(
      async ({ id, forecastDateStart, forecastDateEnd }: IUpdateForecastDatesParams, thinkApi) => {
        try {
          await post(`/api/v2/settlement/floor/${id}/forecast-update/`, {
            forecast_date_start: forecastDateStart,
            forecast_date_end: forecastDateEnd,
          });
        } catch (error) {
          return thinkApi.rejectWithValue(error);
        }
      },
      {
        pending: state => {
          state.updateDateLoading = true;
        },
        fulfilled: state => {
          state.updateDateLoading = false;
        },
        rejected: state => {
          state.updateDateLoading = false;
        },
      },
    ),
  }),
});

export const {
  reset: setReset,
  fetchDetailsData: setDetailsData,
  updateForecastDates: setUpdateForecastDates,
} = deliveryScheduleDetailSlice.actions;
